import { ChevronDown, ChevronUp, Trash2 } from "lucide-react";

const CarouselItem = ({ item, index, onMoveUp, onMoveDown, onDelete, canMoveUp, canMoveDown }) => {
  return (
    <div className="flex items-center gap-2 p-2 border border-gray-300 rounded bg-white">
      <span className="font-bold text-sm w-6">{index + 1}</span>

      {/* {item.thumbnail && (
        <img 
          src={item.thumbnail} 
          alt={item.title}
          className="w-12 h-12 rounded object-cover"
          //onError={(e) => e.target.style.display = 'none'}
        />
      )} */}

      <div className="flex-1">
        <p className="text-sm font-semibold">{item.title}</p>
        <p className="text-xs text-gray-500">{item.redirection_to}</p>
      </div>

      <div className="flex gap-1">
        <button
          type='button'
          onClick={onMoveUp}
          disabled={!canMoveUp}
          className="p-1 hover:bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
          title="Move up"
        >
          <ChevronUp size={18} />
        </button>
        <button
          type='button'
          onClick={onMoveDown}
          disabled={!canMoveDown}
          className="p-1 hover:bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
          title="Move down"
        >
          <ChevronDown size={18} />
        </button>
      </div>
      <button
        onClick={onDelete}
        className="p-1 text-red-500 hover:bg-red-50 rounded"
        title="Delete"
      >
        <Trash2 size={18} />
      </button>
    </div>
  );
};

export default CarouselItem;